// Colour conventions shared by the planning table, the tour list and the map. A tour takes the colour of the
// delivery ZONE its deliverer is REFERENT of (`deliveryZone.color`) — one referent ↔ one zone, never shared,
// so two tours never collide. ZONE chips use the same `deliveryZone.color`. So the zone colours (set by the
// recolour migration) drive everything. Recomputed per view from its rows — deterministic, so the map, the
// tour list and the table headers all agree.

// Fallback when a zone carries no colour of its own.
export const FALLBACK_COLOR = '#07c607';

// Tours / avatars with no deliverer (or a deliverer who isn't a zone referent).
export const UNASSIGNED_COLOR = '#64748b';

type ReferentColorRow = {
    referentDeliverer?: { _id: string } | null;
    deliveryZone?: { color?: string | null } | null;
};

// referentDeliverer id → their zone's colour (one zone per referent → a stable, collision-free map; the
// recolour migration gives each zone a distinct colour). Looked up by a tour's deliverer — who is the referent
// of their own zone — so each tour shows its zone's colour.
export const buildZoneColorByReferent = (rows: ReferentColorRow[]): Map<string, string> => {
    const colors = new Map<string, string>();
    for (const row of rows) {
        const referentId = row.referentDeliverer?._id;
        const color = row.deliveryZone?.color;
        if (referentId && color && !colors.has(referentId)) colors.set(referentId, color);
    }
    return colors;
};

export const initials = (fullname: string): string =>
    fullname
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase() ?? '')
        .join('');
